export const Footer = () => (
  <footer data-testid="footer" className="border-t-4 border-taxi bg-kadak">
    <div className="mx-auto flex max-w-7xl flex-col items-center px-4 py-16 text-center sm:px-6">
      <img src="/assets/logo-roundel.png" alt="Vada Sub roundel" className="w-32 animate-spin-slow sm:w-40" />
      <p className="mt-8 font-shrikhand text-3xl text-taxi sm:text-5xl" style={{ textShadow: "3px 3px 0 #E03A2F" }}>
        Ek sub mein poora Bombay.
      </p>
      <a
        href="mailto:chalo@vadasub.in"
        data-testid="footer-email-cta"
        className="mt-8 rounded-full border-4 border-kadak bg-taxi px-8 py-3 font-bungee text-sm text-kadak sticker-shadow-sm transition-transform duration-150 hover:-translate-y-1 hover:-translate-x-1"
      >
        PILOT PARTNERS & SITES → CHALO@VADASUB.IN
      </a>
      <div className="mt-10 flex flex-wrap justify-center gap-6 font-anton text-xs uppercase tracking-widest text-pav/60">
        <a href="#idea" data-testid="footer-link-idea" className="transition-colors hover:text-taxi">The Idea</a>
        <a href="#menu" data-testid="footer-link-menu" className="transition-colors hover:text-taxi">Menu</a>
        <a href="#stores" data-testid="footer-link-stores" className="transition-colors hover:text-taxi">Stores</a>
        <a href="#franchise" data-testid="footer-link-franchise" className="transition-colors hover:text-taxi">Franchise</a>
      </div>
      <p className="mt-10 text-xs text-pav/40">
        Vada Sub • Est. 2026 • Lamba Vada. Bada Maza. • All numbers illustrative pending pilot data
      </p>
    </div>
    <div className="tape-checker h-6 w-full border-t-4 border-kadak" />
  </footer>
);
